import React, { ReactNode } from "react";
import { About } from "./over";
import { Footer } from "./contact";
import { Header } from "./header";
import { Content } from "./content";
import { Navbar } from "../components/navbar";
import "../index.css";

export const Home = () => {
  return (
    <>
      <div className="App">
        <Navbar />
        <Header
          title="Home"
          subtitle="test"
          id="Home"
        />
        <About
          title="Over Bram"
          subtitle="test"
          id="About"
        />
        <Content
          title="Pinterest"
          subtitle="test"
          id="Pinterest"
        />
        <Footer
          title="Contact"
          subtitle="test"
          id="Contact"
        />
      </div>
    </>
  );
};
